import PropTypes from 'prop-types'
import { FeaturedGuideCard } from 'components/card'
import Link from 'components/link'

const VideoCard = ({ imageUrl, title, teaser, videoId }) => {
  return (
    <Link url={`https://youtube.com/watch?v=${videoId}`} newWindow>
      <FeaturedGuideCard
        bgColor="bubblegum-gradient"
        guideLabel="Video"
        imageUrl={imageUrl}
        teaser={teaser}
        title={title}
        playButtonOverlay={true}
      />
    </Link>
  )
}

VideoCard.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  teaser: PropTypes.string,
  videoId: PropTypes.string.isRequired,
}

export default VideoCard
